import React from "react";

export const StarRating = ({ rating , reviews_count}) => {
    const maxStars = 5;
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0); 
    return (
        <span className="flex items-center text-green text-xs font-medium">
            {/* Render full stars */}
            {[...Array(fullStars)].map((_, index) => (
                <svg key={index} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00045 13.695L3.71036 16.6562L4.89186 10.7099L0.440918 6.59385L6.4612 5.88005L9.00045 0.375L11.5396 5.88005L17.5599 6.59385L13.109 10.7099L14.2905 16.6562L9.00045 13.695Z" fill="#FFC116" />
                </svg>
            ))}

            {/* Render half star if needed */}
            {hasHalfStar && (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00045 11.976L12.1855 13.7588L11.4741 10.1788L14.1539 7.70055L10.5292 7.27075L9.00045 3.95627V11.976ZM9.00045 13.695L3.71036 16.6562L4.89186 10.7099L0.440918 6.59385L6.4612 5.88005L9.00045 0.375L11.5396 5.88005L17.5599 6.59385L13.109 10.7099L14.2905 16.6562L9.00045 13.695Z" fill="#FFC116" />
                </svg>
            )}

            {/* Render empty stars */}
            {[...Array(emptyStars)].map((_, index) => (
                <svg key={`empty-${index}`} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.00045 13.695L3.71036 16.6562L4.89186 10.7099L0.440918 6.59385L6.4612 5.88005L9.00045 0.375L11.5396 5.88005L17.5599 6.59385L13.109 10.7099L14.2905 16.6562L9.00045 13.695Z" fill="#E0E0E0" />
                </svg>
            ))}

            {/* Rating Value & Review Count */}
            <span className="mx-1 text-dark">
                {rating !== 0.00 ? `(${rating.toFixed(2)})` : null}
            </span>
            {reviews_count !== 0 ? `${reviews_count} Reviews` : 'Not Reviews Yet'}
        </span>
    );
};